import React from 'react';

import { Dialog, Typography, Stack, Button } from '@gogame/components';

const CreateSAWithBigPeriodDialog = ({ onClose, open, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.Content>
        <Stack spacing={2}>
          <Typography variant={'h6'}>Zendesk Ticket Required</Typography>
          <Typography>
            Spend adjustments created for periods of more than 4 months back
            cannot be applied automatically. Please submit a Zendesk ticket
            after you create a Spend adjustment indicating a spend
            adjustment/campaign ID in order for us to apply it manually. Note:
            the process might take some time as it will imply historical
            re-calculation of data.
          </Typography>
        </Stack>
      </Dialog.Content>

      <Dialog.Actions>
        <Button onClick={onSubmit} variant={'outlined'}>
          Close
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default CreateSAWithBigPeriodDialog;
